import AbstractConfigProvider from './AbstractConfigProvider';

export default class AppConfigProvider extends AbstractConfigProvider {
    public prefix: string = 'app';

    public getConfig() {
        return {
            ...this.add('currency', process.env.MIX_CURRENCY),
            ...this.add('env', process.env.MIX_ENV),
            ...this.add('locale', process.env.MIX_LOCALE),
            ...this.add('supported_locales', process.env.MIX_SUPPORTED_LOCALES),
            ...this.add('fraction_digits', process.env.MIX_FRACTION_DIGITS),
            ...this.add('url', process.env.MIX_APP_URL),
        };
    }
}
